import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { io, type Socket } from 'socket.io-client'

import { addOnlineUser } from '@/features/app/appSlice'

import {
    setChatById,
    setChatUserStatus,
    setNewChat,
    setNewMessage,
    setRemoveChat,
    setRemoveMessage,
    setUpdateMessage,
} from '../features/chat/chatSlice'
import { setNotification } from '../features/notifications/notificationsSlice'

const socketEvents = {
    NEW_ORDER: 'new_order',
    UPDATED_ORDER: 'updated_order',
    NEW_ORDER_ASSIGNMENTS: 'new_order_assignments',
    UPDATE_ORDER_EXECUTIONS: 'update_order_executions',
    NEW_NOTIFICATION: 'new_notification',
    NEW_CHAT: 'new_chat',
    DELETED_CHAT: 'deleted_chat',
    NEW_MESSAGE: 'new_message',
    UPDATED_MESSAGE: 'updated_message',
    DELETED_MESSAGE: 'deleted_message',
    READ_MESSAGE: 'read_message',
    ONLINE_STATUS: 'online_status',
    UPDATED_CHAT: 'updated_chat',
}

const SOCKET_URL = import.meta.env.VITE_API_URL

const SocketProvider = () => {
    const dispatch = useDispatch()
    const socketRef = useRef<Socket | null>(null)

    useEffect(() => {
        const token = localStorage.getItem('authToken')
        if (!token) return

        const socket = io(SOCKET_URL, {
            path: '/socket',
            transports: ['websocket'],
            auth: { token },
        })

        socketRef.current = socket

        socket.connect()

        socket.on(socketEvents.ONLINE_STATUS, (data) => {
            dispatch(addOnlineUser(data))
            console.log(data, 'ONLINE_STATUS')
        })

        socket.on(socketEvents.NEW_MESSAGE, (data) => {
            dispatch(setNewMessage(data))
            console.log(data, 'NEW_MESSAGE')
        })

        // socket.on(socketEvents.READ_MESSAGE, (data) => {
        //     dispatch(readMessages(data))
        //     console.log(data, 'READ_MESSAGE');
        // })
        socket.on(socketEvents.UPDATED_MESSAGE, (data) =>
            dispatch(setUpdateMessage(data)),
        )
        socket.on(socketEvents.DELETED_MESSAGE, (data) =>
            dispatch(setRemoveMessage(data)),
        )
        socket.on(socketEvents.NEW_CHAT, (data) => dispatch(setNewChat(data)))
        socket.on(socketEvents.NEW_NOTIFICATION, (data) =>
            dispatch(setNotification(data)),
        )
        socket.on(socketEvents.DELETED_CHAT, (data) =>
            dispatch(setRemoveChat(data)),
        )
        socket.on(socketEvents.ONLINE_STATUS, (data) =>
            dispatch(setChatUserStatus(data)),
        )
        socket.on(socketEvents.UPDATED_CHAT, (data) => {
            dispatch(setChatById(data))
            console.log(data, 'UPDATED_CHAT')
        })

        return () => {
            socket.disconnect()
        }
    }, [dispatch])

    return null
}

export default SocketProvider
